"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useGridKeyboardNavigation_1 = __importDefault(require("../../../hooks/useGridKeyboardNavigation/useGridKeyboardNavigation"));
const useMergeRefs_1 = __importDefault(require("../../../hooks/useMergeRefs"));
const usePrevious_1 = __importDefault(require("../../../hooks/usePrevious"));
const function_utils_1 = require("../../../utils/function-utils");
require("./TabList.scss");
const TabList = (0, react_1.forwardRef)(({ className, id, onTabChange = function_utils_1.NOOP, activeTabId = 0, tabType = "Compact", size, children }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const [activeTabState, setActiveTabState] = (0, react_1.useState)(activeTabId);
    const prevActiveTabIdProp = (0, usePrevious_1.default)(activeTabId);
    (0, react_1.useEffect)(() => {
        // Update active tab if changed from props
        if (activeTabId !== prevActiveTabIdProp && activeTabId !== activeTabState) {
            setActiveTabState(activeTabId);
        }
    }, [activeTabId, prevActiveTabIdProp, activeTabState, setActiveTabState]);
    const disabledTabIds = (0, react_1.useMemo)(() => {
        const disabledIds = new Set();
        react_1.default.Children.forEach(children, (child, index) => {
            if (child.props.disabled) {
                disabledIds.add(index);
            }
        });
        return disabledIds;
    }, [children]);
    const onTabSelect = (0, react_1.useCallback)((tabId) => {
        if (disabledTabIds.has(tabId))
            return;
        setActiveTabState(tabId);
        onTabChange && onTabChange(tabId);
    }, [onTabChange, disabledTabIds]);
    const onTabClick = (0, react_1.useCallback)((value, tabId) => {
        const tabCallbackFunc = children[tabId].props.onClick;
        if (disabledTabIds.has(tabId))
            return;
        if (tabCallbackFunc)
            tabCallbackFunc(tabId);
        onTabSelect(tabId);
    }, [children, disabledTabIds, onTabSelect]);
    const getItemByIndex = (0, react_1.useCallback)((index) => children[index], [children]);
    const disabledIndexes = (0, react_1.useMemo)(() => Array.from(disabledTabIds), [disabledTabIds]);
    const ulRef = (0, react_1.useRef)();
    const { activeIndex: focusIndex, onSelectionAction } = (0, useGridKeyboardNavigation_1.default)({
        ref: ulRef,
        numberOfItemsInLine: children === null || children === void 0 ? void 0 : children.length,
        itemsCount: children === null || children === void 0 ? void 0 : children.length,
        getItemByIndex,
        onItemClicked: onTabClick,
        disabledIndexes
    });
    const tabsToRender = (0, react_1.useMemo)(() => {
        const childrenToRender = react_1.default.Children.map(children, (child, index) => {
            return react_1.default.cloneElement(child, {
                value: index,
                active: activeTabState === index,
                focus: focusIndex === index,
                onClick: onSelectionAction
            });
        });
        return childrenToRender;
    }, [children, activeTabState, focusIndex, onSelectionAction]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("tabs--wrapper", className, tabType), id: id }, { children: (0, jsx_runtime_1.jsx)("ul", Object.assign({ ref: ulRef, tabIndex: 0, className: (0, classnames_1.default)("tabs-list", size), role: "tablist" }, { children: tabsToRender })) })));
});
Object.assign(TabList, {
    isTabList: true
});
exports.default = TabList;
